import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useT } from "../lib/i18n";

import { tr } from "../lib/i18n";
/** Cars out on inspection or test drive right now; overdue ones in red. */
export const OutNowPanel = () => {
  const nav = useNavigate();
  const [data, setData] = useState({ items: [], overdue_count: 0 });
  const { t } = useT();
  useEffect(() => {
    api.get("/forms/out-now").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  const shown = [...data.items].sort((a, b) => Number(b.overdue) - Number(a.overdue)).slice(0, 8);
  return (
    <section className="panel" data-testid="out-now-panel">
      <div className="panel-title flex items-center justify-between">
        <div className="kicker">{t("on.title")}</div>
        {data.overdue_count > 0 && <span className="pill" style={{ background: "#dc2626", color: "#fff" }} data-testid="out-now-overdue-count">{t("on.overdue_n", { n: data.overdue_count })}</span>}
      </div>
      <div className="panel-body">
        {data.items.length === 0 && <div className="text-sm opacity-60">{tr("x.no_cars_out_on_inspection_or_test_drive")}</div>}
        {shown.map((f) => (
          <button key={f.id} onClick={() => nav("/forms")} data-testid={`out-now-${f.reference}`}
            className={`w-full flex justify-between gap-3 py-2 text-sm text-start ${f.overdue ? "text-red-600 font-semibold" : ""}`}
            style={{ borderBottom: "1px solid var(--divider-soft)" }}>
            <span>{f.form_type === "inspection" ? t("on.inspection") : t("on.test_drive")} · {f.vehicle_label}</span>
            <span className="tabular">{f.overdue ? `${t("on.overdue")} · ` : `${t("on.due")} `}<bdi dir="ltr">{(f.expected_return_at || "—").slice(0, 16).replace("T", " ")}</bdi></span>
          </button>
        ))}
        {data.items.length > shown.length && (
          <button onClick={() => nav("/forms")} className="text-xs text-accent-brand font-semibold mt-2" data-testid="out-now-view-all">{t("on.view_all", { n: data.items.length })} <span className="flip-rtl" style={{ display: "inline-block" }}>→</span></button>
        )}
      </div>
    </section>
  );
};
